import { createContext } from 'react'
import type { User } from '../../data/users'

export interface OneLoginSession {
  at_hash?: string
  aud: string
  email: string
  email_verified?: boolean
  exp: number
  family_name: string
  given_name: string
  iat: number
  iss: string
  name: string
  preferred_username?: string
  sid?: string
  sub: string
  updated_at: number
  loggedInAt: number
}

export interface AuthContextType {
  user: User | null
  login: (session: OneLoginSession) => Promise<void>
  passwordLogin: (email: string, password: string) => Promise<void>
  logout: () => Promise<void>
  loading: boolean
}

export const AuthContext = createContext<AuthContextType | undefined>(undefined)
